<div class="thumbnail-container">
  @if (isGuest) {
    @if (isPdf || isPdfConvertable) {
      <button
        aria-label="Thumbnail Preview Button"
        [ngClass]="{ 'pdf-preview-open': isPdfPreviewOpen() }"
        mat-icon-button
        (click)="onClickThumbnailIcon($event)"
      >
        <mat-icon>preview</mat-icon>
      </button>
    } @else {
      <div
        [matTooltip]="'NO_EXPORT_PERMISSION_MSG' | transloco"
        [matTooltipDisabled]="permissions.exportDocuments"
        matTooltipPosition="right"
      >
        <button
          aria-label="Download Document Button"
          [disabled]="!permissions.exportDocuments"
          mat-icon-button
          (click)="onClickDownload($event)"
        >
          <mat-icon>{{
            permissions.exportDocuments ? 'file_download' : 'file_download_off'
          }}</mat-icon>
        </button>
      </div>
    }
  } @else {
    <button
      aria-label="Thumbnail Preview Button"
      mat-icon-button
      (click)="onClickThumbnailIcon($event)"
      [ngClass]="{ 'pdf-preview-open': isPdfPreviewOpen() }"
    >
      @if (!isSvgIcon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (isSvgIcon) {
        <mat-icon [svgIcon]="icon"></mat-icon>
      }
    </button>
  }
</div>
